import { render, staticRenderFns } from "./ReportLoad.vue?vue&type=template&id=28ab79c8&scoped=true&"
import script from "./ReportLoad.vue?vue&type=script&lang=js&"
export * from "./ReportLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab79c8",
  null
  
)

export default component.exports